import {Component, inject, Input, WritableSignal} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {RouterLink} from '@angular/router';
import {pdeRoutes} from '@app/routing/routes';
import {GenericTileListComponent} from '@app/tiles/generic-tile-list/generic-tile-list.component';
import {TileInfo} from '@models/tile-info';
import {ProjectBaseModel} from '@project/project-base.model';
import {
  KeyValueTableComponent,
  keyValueTableObject,
} from '@shared/components/key-value-table/key-value-table.component';

@Component({
  selector: 'app-project-base',
  templateUrl: './project-base.component.html',
  imports: [GenericTileListComponent, KeyValueTableComponent, MatIconModule, MatButtonModule, RouterLink],
})
export class ProjectBaseComponent {
  @Input({required: true}) project!: WritableSignal<ProjectBaseModel | null>;
  @Input() datasetTiles: TileInfo[] = [];
  @Input() resourceTiles: TileInfo[] = [];
  @Input() metaTableData!: keyValueTableObject;
  @Input() showSidebar = true;
  private readonly sanitizer = inject(DomSanitizer);
  protected readonly pdeRoutes = pdeRoutes;

  get safeDescription(): SafeHtml {
    const description = this.project()?.description ?? '';
    return this.sanitizer.bypassSecurityTrustHtml(description); // nosonar
  }
}
